export const PAGE_SIZE = 10;
export const AFTER_API_TIME = 1000;
export const ViewModalBorderRadius = 2;
export const getApiUrl = (base) => {
    const env = process.env.REACT_APP_ENV;
    console.log("API ENV:", env);
    if (env === "prod") {
        return `https://api.constrogen.com/${base}`;
    }
    else {
        return `https://dev.constrogen.com/${base}`;
        // return `http://localhost:8000/${base}`
    }
};
